import { render, staticRenderFns } from "./Changepassword.vue?vue&type=template&id=6528c44f&"
import script from "./Changepassword.vue?vue&type=script&lang=ts&"
export * from "./Changepassword.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ubuntu/agent/workspace/SPP/deployment/frontend-erp-spp/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6528c44f')) {
      api.createRecord('6528c44f', component.options)
    } else {
      api.reload('6528c44f', component.options)
    }
    module.hot.accept("./Changepassword.vue?vue&type=template&id=6528c44f&", function () {
      api.rerender('6528c44f', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/user-management/Changepassword.vue"
export default component.exports